// List of Brantree errors
// Uncomment these that should display message to user, all others will result in Generic Payment error
// Full list with descriptions at:
// https://developers.braintreepayments.com/reference/general/processor-responses/authorization-responses

export default {
  // 'Do Not Honor': 'Do Not Honor',
  // 'Insufficient Funds': 'Insufficient Funds',
  // 'Limit Exceeded': 'Limit Exceeded',
  // "Cardholder's Activity Limit Exceeded": "Cardholder's Activity Limit Exceeded",
  // 'Expired Card': 'Expired Card',
  // 'Invalid Credit Card Number': 'Invalid Credit Card Number',
  // 'Invalid Expiration Date': 'Invalid Expiration Date',
  // 'No Account': 'No Account',
  // 'Card Account Length Error': 'Card Account Length Error',
  // 'No Such Issuer': 'No Such Issuer',
  // 'Card Issuer Declined CVV': 'Card Issuer Declined CVV',
  // 'Voice Authorization Required': 'Voice Authorization Required',
  // 'Processor Declined – Possible Lost Card': 'Processor Declined – Possible Lost Card',
  // 'Processor Declined – Possible Stolen Card': 'Processor Declined – Possible Stolen Card',
  // 'Processor Declined – Fraud Suspected': 'Processor Declined – Fraud Suspected',
  // 'Transaction Not Allowed': 'Transaction Not Allowed',
  // 'Duplicate Transaction': 'Duplicate Transaction',
  // 'Cardholder Stopped Billing': 'Cardholder Stopped Billing',
  // 'Cardholder Stopped All Billing': 'Cardholder Stopped All Billing',
  // 'Invalid Transaction': 'Invalid Transaction',
  // Violation: 'Violation',
  // 'Security Violation': 'Security Violation',
  // 'Declined – Updated Cardholder Available': 'Declined – Updated Cardholder Available',
  // 'Processor Does Not Support This Feature': 'Processor Does Not Support This Feature',
  // 'Card Type Not Enabled': 'Card Type Not Enabled',
  // 'Set Up Error – Merchant': 'Set Up Error – Merchant',
  // 'Invalid Merchant ID': 'Invalid Merchant ID',
  // 'Set Up Error – Amount': 'Set Up Error – Amount',
  // 'Set Up Error – Hierarchy': 'Set Up Error – Hierarchy',
  // 'Set Up Error – Card': 'Set Up Error – Card',
  // 'Set Up Error – Terminal': 'Set Up Error – Terminal',
  // 'Encryption Error': 'Encryption Error',
  // 'Surcharge Not Permitted': 'Surcharge Not Permitted',
  // 'Inconsistent Data': 'Inconsistent Data',
  // 'No Action Taken': 'No Action Taken',
  // 'Partial Approval For Amount In Group III Version': 'Partial Approval For Amount In Group III Version',
  // 'Authorization could not be found': 'Authorization could not be found',
  // 'Already Reversed': 'Already Reversed',
  // 'Processor Declined': 'Processor Declined',
  // 'Invalid Authorization Code': 'Invalid Authorization Code',
  // 'Invalid Store': 'Invalid Store',
  // 'Declined – Call For Approval': 'Declined – Call For Approval',
  // 'Invalid Client ID': 'Invalid Client ID',
  // 'Error – Do Not Retry, Call Issuer': 'Error – Do Not Retry, Call Issuer',
  // 'Declined – Call Issuer': 'Declined – Call Issuer',
  // 'Invalid Merchant Number': 'Invalid Merchant Number',
  // Declined: 'Declined',
  // 'Call Issuer. Pick Up Card': 'Call Issuer. Pick Up Card',
  // 'Invalid Amount': 'Invalid Amount',
  // 'Invalid SKU Number': 'Invalid SKU Number',
  // 'Invalid Credit Plan': 'Invalid Credit Plan',
  // 'Credit Card Number does not match method of payment': 'Credit Card Number does not match method of payment',
  // 'Invalid level III Purchase': 'Invalid level III Purchase',
  // 'Card reported as lost or stolen': 'Card reported as lost or stolen',
  // 'Reversal amount does not match authorization amount': 'Reversal amount does not match authorization amount',
  // 'Invalid Transaction Division Number': 'Invalid Transaction Division Number',
  // 'Transaction amount exceeds the transaction division limit': 'Transaction amount exceeds the transaction division limit',
  // 'Issuer or Cardholder has put a restriction on the card': 'Issuer or Cardholder has put a restriction on the card',
  // 'Merchant not Mastercard SecureCode enabled': 'Merchant not Mastercard SecureCode enabled',
  // 'Address Verification Failed': 'Address Verification Failed',
  // 'Address Verification and Card Security Code Failed': 'Address Verification and Card Security Code Failed',
  // 'Invalid Transaction Data': 'Invalid Transaction Data',
  // 'Invalid Tax Amount': 'Invalid Tax Amount',
  // 'PayPal Business Account preference resulted in the transaction failing': 'PayPal Business Account preference resulted in the transaction failing',
  // 'Invalid Currency Code': 'Invalid Currency Code',
  // 'Refund Time Limit Exceeded': 'Refund Time Limit Exceeded',
  // 'PayPal Business Account Restricted': 'PayPal Business Account Restricted',
  'Authorization Expired': 'Authorization Expired',
  // 'PayPal Business Account Locked or Closed': 'PayPal Business Account Locked or Closed',
  // 'PayPal Blocking Duplicate Order IDs': 'PayPal Blocking Duplicate Order IDs',
  'PayPal Buyer Revoked Pre-Approved Payment Authorization': 'PayPal Buyer Revoked Pre-Approved Payment Authorization',
  'PayPal Payee Account Invalid Or Does Not Have a Confirmed Email': 'PayPal Payee Account Invalid Or Does Not Have a Confirmed Email',
  'PayPal Payee Email Incorrectly Formatted': 'PayPal Payee Email Incorrectly Formatted',
  // 'PayPal Validation Error': 'PayPal Validation Error',
  "Funding Instrument In The PayPal Account Was Declined By The Processor Or Bank, Or It Can't Be Used For This Payment":
    "Funding Instrument In The PayPal Account Was Declined By The Processor Or Bank, Or It Can't Be Used For This Payment",
  'Payer Account Is Locked Or Closed': 'Payer Account Is Locked Or Closed',
  'Payer Cannot Pay For This Transaction With PayPal': 'Payer Cannot Pay For This Transaction With PayPal',
  'Transaction Refused Due To PayPal Risk Model': 'Transaction Refused Due To PayPal Risk Model'
  // 'Invalid Secure Payment Data': 'Invalid Secure Payment Data',
  // 'PayPal Merchant Account Configuration Error': 'PayPal Merchant Account Configuration Error',
  // 'Invalid user credentials': 'Invalid user credentials',
  // 'PayPal pending payments are not supported': 'PayPal pending payments are not supported',
  // 'PayPal Domestic Transaction Required': 'PayPal Domestic Transaction Required',
  // 'PayPal Phone Number Required': 'PayPal Phone Number Required',
  // 'PayPal Tax Info Required': 'PayPal Tax Info Required',
  // 'PayPal Payee Blocked Transaction': 'PayPal Payee Blocked Transaction',
  // 'PayPal Transaction Limit Exceeded': 'PayPal Transaction Limit Exceeded',
  // 'PayPal reference transactions not enabled for your account': 'PayPal reference transactions not enabled for your account',
  // 'Currency not enabled for your PayPal seller account': 'Currency not enabled for your PayPal seller account',
  // 'PayPal payee email permission denied for this request': 'PayPal payee email permission denied for this request',
  // 'PayPal account not configured to refund more than settled amount': 'PayPal account not configured to refund more than settled amount',
  // 'Currency of this transaction must match currency of your PayPal account':
  //   'Currency of this transaction must match currency of your PayPal account',
  // 'No Data Found - Try Another Verification Method': 'No Data Found - Try Another Verification Method',
  // 'PayPal payment method is invalid': 'PayPal payment method is invalid',
  // 'PayPal payment has already been completed': 'PayPal payment has already been completed',
  // 'PayPal refund is not allowed after partial refund': 'PayPal refund is not allowed after partial refund',
  // "PayPal buyer account can't be the same as the seller account": "PayPal buyer account can't be the same as the seller account",
  // 'PayPal authorization amount limit exceeded': 'PayPal authorization amount limit exceeded',
  // 'PayPal authorization count limit exceeded': 'PayPal authorization count limit exceeded',
  // 'Cardholder Authentication Required': 'Cardholder Authentication Required',
  // 'PayPal channel initiated billing not enabled for your account': 'PayPal channel initiated billing not enabled for your account',
  // 'Additional authorization required': 'Additional authorization required',
  // 'Incorrect PIN': 'Incorrect PIN',
  // 'PIN try exceeded': 'PIN try exceeded',
  // 'Offline Issuer Declined': 'Offline Issuer Declined',
  // 'Processor Network Unavailable – Try Again': 'Processor Network Unavailable – Try Again'
}
